var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStakeSolid = function SvgStakeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.385 8c0 1.243 1 2.243 3 4.243l.444.443c2 2 3 3 4.242 3 1.243 0 2.243-1 4.243-3l.444-.443c2-2 3-3 3-4.243 0-1.243-1-2.243-3-4.243l-.444-.443c-2-2-3-3-4.243-3-1.242 0-2.242 1-4.242 3l-.444.443c-2 2-3 3-3 4.243Zm11.367-.84a1 1 0 1 0-1.504-1.32l-1.18 1.348-.846-.88a1 1 0 0 0-1.429-.015l-2 2a1 1 0 0 0 1.415 1.414L7.486 8.43l.893.93a1 1 0 0 0 1.473-.033l1.9-2.167Z",
    clipRule: "evenodd"
  })));
};
export default SvgStakeSolid;